export default __webpack_public_path__ + "static/media/expand.bea4582f.svg";